import showroom1 from '../images/showroom-slide/showroom1.jpg'
import showroom2 from '../images/showroom-slide/showroom2.jpg'
import showroom3 from '../images/showroom-slide/showroom3.jpg'
import showroom4 from '../images/showroom-slide/showroom4.jpg'

export default [ showroom1, showroom2, showroom3, showroom4 ]